import { Injectable } from '@angular/core';
import { ColumnDefinition, TableFilterItem } from './table.types';

@Injectable({
    providedIn: 'root'
})
export class TableMergeService {
    constructor() {}

    mergeFilterItems(toMerge: Array<Array<TableFilterItem>>) {
        const toReturn: Array<TableFilterItem> = [];
        if (!toMerge) {
            return toReturn;
        }

        toMerge.forEach((value: Array<TableFilterItem>) => {
            if (!value) {
                return;
            }
            if (value && value.length) {
                value.forEach((item) => {
                    if (!item) {
                        return;
                    }
                    if (!toReturn.find((m) => m.property === item.property)) {
                        toReturn.push(item);
                    }
                });
            }
        });
        return toReturn;
    }

    mergeColumns(toMerge: Array<Array<ColumnDefinition>>) {
        const toReturn: Array<ColumnDefinition> = [];
        if (!toMerge) {
            return toReturn;
        }

        toMerge.forEach((value: Array<ColumnDefinition>) => {
            if (!value) {
                return;
            }
            if (value && value.length) {
                value.forEach((item) => {
                    if (!item) {
                        return;
                    }
                    if (!toReturn.find((m) => m.property === item.property)) {
                        toReturn.push(item);
                    }
                });
            }
        });
        return toReturn;
    }
}
